<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Loja Virtual</h2>

          <p>Antes de criar sua loja virtual é importante saber:</p>
          <ul>
            <li>A <strong>loja virtual será um revendedor</strong> em seu evento, portanto o gerenciamento dos lotes disponíveis para venda online deve ser feito em
              <router-link :to="{ name: 'OrganizerDealers' }"><strong>Revendedores</strong></router-link>;
            </li>
            <li>Os saques devem ser solicitados aos administradores da Easytick com antecedência;</li>
            <li>O comprador irá receber os <strong>ingressos por e-mail</strong> assim que confirmado o pagamento;</li>
            <li>Por padrão a loja virtual é ativada com todos os lotes disponíveis, portanto é importante configurar quais lotes você quer deixar visíveis antes de divulgar o link de sua loja. Para isto vá para <router-link :to="{ name: 'OrganizerDealers' }"><strong>Revendedores</strong></router-link>.</li>
            <li>Vendas online encerram-se 12 horas após a data do evento</li>
            <li>Vendas por boleto encerram-se 4 dias antes da data do evento</li>
          </ul>

          <div v-if="virtualStore === 1">
            <b-btn @click="createStore" v-if="!has_online_dealer">
              <icon scale="2" name="shopping-cart"></icon> <strong>Criar minha loja virtual</strong>
            </b-btn>
            <div v-if="has_online_dealer">
              <b-alert variant="success" show>
                <strong>Sua loja virtual está criada!</strong> <br>
                Se deseja gerenciar os lotes da loja vá para <router-link :to="{ name: 'OrganizerDealers' }"><strong>Revendedores</strong></router-link>.
              </b-alert>
            </div>
          </div>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'OrganizerCreateStore',
  data () {
    return {
      organizer: '',
      has_online_dealer: false,
      virtualStore: false,
      batches: [],
      feedback: false,
      form: {
        name: 'Loja Virtual',
        type: 'online',
        batches: []
      }
    }
  },
  mounted () {
    this.organizer = this.$route.params.organizer
    this.getEvent()
      .then(res => {
        this.has_online_dealer = res.body.has_online_dealer
        this.virtualStore = res.body.virtual_store
      })
  },
  methods: {
    getEvent () {
      let url = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/events`
      return this.$http.get(url)
        .then(res => {
          if (res.body.batches.length > 0) {
            let batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
            this.batches = this.$_.filter(batches, b => b.is_available === 1)
          }
          return res
        })
    },
    createStore () {
      let url = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers`
      this.form.batches = this.batches.map(b => b.id)
      this.$http.post(url, this.form)
        .then(res => {
          this.feedback = true
          this.has_online_dealer = true
        }, err => {
          alert(err.body.message)
          console.log(err)
        })
    }
  }
}
</script>
